/** @jsx jsx */
// @ts-check
import { graphql } from 'gatsby';
import shuffle from 'lodash/shuffle';
import React from 'react';
import { jsx } from 'theme-ui';
import Layout from '../Layout';
import SEO from '../seo.js';
import LandingPageSections from './LandingPageSections';

export default function LandingPage({
  event,
  localeConfig,
  exhibitors,
  producers,
  location,

  segments,
  locale,
  withOverlay,
  displayedFeaturedExhibitors,
}) {
  const shuffledExhibitors = React.useMemo(
    () => shuffle(exhibitors).slice(0, displayedFeaturedExhibitors),
    [displayedFeaturedExhibitors, exhibitors]
  );
  const shuffledProducers = React.useMemo(
    () => shuffle(producers).slice(0, displayedFeaturedExhibitors),
    [displayedFeaturedExhibitors, producers]
  );
  return (
    <Layout locale={locale} sx={{ backgroundColor: 'light' }} hideSearch>
      <SEO page={{ path: location.href }} />
      <LandingPageSections
        event={event}
        localeConfig={localeConfig}
        videos={event.videos}
        files={event.files?.nodes}
        locale={locale}
        segments={segments}
        shuffledExhibitors={shuffledExhibitors}
        shuffledProducers={shuffledProducers}
        withOverlay={withOverlay}
      />
    </Layout>
  );
}

export const fragment = graphql`
  fragment bb_LandingPage on Bottlebooks_Event {
    ...bb_LandingPageSections
  }

  fragment LandingPage_FeaturedExhibitors on Exhibitor {
    ...LandingPageSections_FeaturedExhibitors
  }

  fragment LandingPage_LocaleConfig on LocaleConfig {
    ...LandingPageSections
  }
`;
